// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-loop-action-filter-condition' )
export class AutomatorTemplateLoopActionFilterCondition extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The code of the associated integration.
	 *
	 * @type {String}
	 * @property {String} integrationCode - Represents the code of the integration.
	 * Attribute name in HTML: `integration-code`.
	 */
	@property( { type: String, attribute: 'integration-code' } )
	accessor integrationCode;

	/**
	 * The title of the condition.
	 *
	 * @type {String}
	 * @property {String} title - The title text for the condition.
	 * Attribute name in HTML: `title`.
	 * Default: `''`.
	 */
	@property( { type: String } )
	accessor title = '';

	/**
	 * The HTML version of the title, used for rendering the condition sentence.
	 *
	 * @type {String}
	 * @property {String} titleHTML - The HTML content for the title.
	 * Attribute name in HTML: none (non-reflected property).
	 */
	@property( { type: String, attribute: false } )
	accessor titleHTML = '';

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="condition"
			>
				${ this._templateIcon }
				${ this._templateSentence }
			</div>
		`;
	}

	/**
	 * Returns the template that renders the integration icon
	 *
	 * @return {TemplateResult} The icon
	 */
	get _templateIcon() {
		return html`
			<div class="condition__icon">
				<uo-icon integration="${ this.integrationCode }" show-tooltip></uo-icon>
			</div>
		`;
	}

	/**
	 * Returns the template that renders the condition sentence
	 *
	 * @return {TemplateResult} The sentence
	 */
	get _templateSentence() {
		return html`
			<div class="condition__sentence">
				<uap-template-sentence .sentence="${ this.titleHTML }"></uap-template-sentence>
			</div>
		`;
	}
}